function mapDeliveryEstimation(data, locale) {
    var ref, ref1, ref2;
    const response = data === null || data === void 0 ? void 0 : (ref = data.deliveryEstimation) === null || ref === void 0 ? void 0 : ref.response;
    if (!response) return null;
    var ref3;
    const deliveryEstimation = {
        shippingMethodDescription: (ref3 = (ref2 = (ref1 = response.shippingMethodDescription) === null || ref1 === void 0 ? void 0 : ref1.find((description)=>description.locale === locale || description.locale === locale.substr(0, 2)
        )) === null || ref2 === void 0 ? void 0 : ref2.value) !== null && ref3 !== void 0 ? ref3 : ''
    };
    if ('deliveryRanges' in response) {
        deliveryEstimation.deliveryRanges = {
            min: response.deliveryRanges.min,
            max: response.deliveryRanges.max,
            minWithPrescription: response.deliveryRanges.minWithPrescription,
            maxWithPrescription: response.deliveryRanges.maxWithPrescription
        };
    }
    if ('deliveryDate' in response) {
        deliveryEstimation.deliveryDate = response.deliveryDate ? new Date(response.deliveryDate) : undefined;
    }
    return deliveryEstimation;
}

export { mapDeliveryEstimation };
//# sourceMappingURL=delivery-estimation.js.map
